import React, { useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { mockUsers } from '../utils/mockData';
import { ArrowLeft, X, Download, Check, Calendar, Clock, FileText, User, Mail, Phone, Home, Zap, Battery, Sun, DollarSign, Leaf, ChevronRight } from 'lucide-react';
export const ProposalDetail = () => {
  const {
    userId,
    proposalId
  } = useParams<{
    userId: string;
    proposalId: string;
  }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('overview');
  const user = mockUsers.find(u => u.id === userId);
  const proposal = user?.projects.find(p => p.id === proposalId);
  // Determine if we came from proposals page or user detail page
  const cameFromProposals = location.state?.from === 'proposals' || location.pathname.includes('/proposals') || document.referrer.includes('/proposals');
  const handleBackClick = () => {
    if (cameFromProposals) {
      navigate('/proposals');
    } else {
      navigate(`/users/${userId}`);
    }
  };
  if (!user || !proposal) {
    return <div className="p-6" data-id="element-118">
        <div className="max-w-6xl mx-auto" data-id="element-119">
          <h1 className="text-2xl font-bold mb-6" data-id="element-120">Proposal not found</h1>
          <button onClick={handleBackClick} className="flex items-center text-primary" data-id="element-121">
            <ArrowLeft className="h-4 w-4 mr-2" data-id="element-122" />
            {cameFromProposals ? 'Back to Proposals' : 'Back to User'}
          </button>
        </div>
      </div>;
  }
  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <div className="space-y-8" data-id="element-123">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-124">
              <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-125">
                <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-126">
                  <h3 className="font-semibold flex items-center" data-id="element-127">
                    <FileText className="h-4 w-4 mr-2 text-primary" data-id="element-128" />
                    Quote Information
                  </h3>
                </div>
                <div className="p-6" data-id="element-129">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-130">
                    <div data-id="element-131">
                      <p className="text-sm text-muted-foreground mb-1" data-id="element-132">
                        Generated Date
                      </p>
                      <p className="font-medium" data-id="element-133">16/07/2025</p>
                    </div>
                    <div data-id="element-134">
                      <p className="text-sm text-muted-foreground mb-1" data-id="element-135">
                        Expiry Date
                      </p>
                      <p className="font-medium text-red-500" data-id="element-136">
                        15/08/2025 (30 days left)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-137">
                <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-138">
                  <h3 className="font-semibold flex items-center" data-id="element-139">
                    <User className="h-4 w-4 mr-2 text-primary" data-id="element-140" />
                    Customer Information
                  </h3>
                </div>
                <div className="p-6" data-id="element-141">
                  <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-142">
                    <div data-id="element-143">
                      <p className="text-sm text-muted-foreground mb-1" data-id="element-144">Name</p>
                      <p className="font-medium" data-id="element-145">{user.name}</p>
                    </div>
                    <div data-id="element-146">
                      <p className="text-sm text-muted-foreground mb-1" data-id="element-147">
                        Email
                      </p>
                      <p className="font-medium" data-id="element-148">{user.email}</p>
                    </div>
                    <div data-id="element-149">
                      <p className="text-sm text-muted-foreground mb-1" data-id="element-150">
                        Phone
                      </p>
                      <p className="font-medium" data-id="element-151">{user.mobile}</p>
                    </div>
                    <div data-id="element-152">
                      <p className="text-sm text-muted-foreground mb-1" data-id="element-153">
                        Verified
                      </p>
                      <div className="flex items-center font-medium text-green-600" data-id="element-154">
                        <Check className="h-4 w-4 mr-1" data-id="element-155" />
                        Yes
                      </div>
                    </div>
                  </div>
                  <div data-id="element-156">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-157">
                      Address
                    </p>
                    <p className="font-medium" data-id="element-158">{proposal.address}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-159">
              <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-160">
                <h3 className="font-semibold flex items-center" data-id="element-161">
                  <Zap className="h-4 w-4 mr-2 text-primary" data-id="element-162" />
                  Performance Summary
                </h3>
              </div>
              <div className="p-6" data-id="element-163">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-164">
                  <div className="text-center p-4 rounded-lg bg-blue-50" data-id="element-165">
                    <p className="text-2xl font-bold text-blue-600" data-id="element-166">1997 kWh</p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-167">
                      Monthly Production
                    </p>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-green-50" data-id="element-168">
                    <p className="text-2xl font-bold text-green-600" data-id="element-169">100%</p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-170">
                      Energy Offset
                    </p>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-purple-50" data-id="element-171">
                    <p className="text-2xl font-bold text-purple-600" data-id="element-172">R886</p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-173">
                      Monthly Savings
                    </p>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-orange-50" data-id="element-174">
                    <p className="text-2xl font-bold text-orange-600" data-id="element-175">
                      15 years
                    </p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-176">
                      Payback Period
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-177">
              <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-178">
                <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-179">
                  <h3 className="font-semibold flex items-center" data-id="element-180">
                    <ChevronRight className="h-4 w-4 mr-2 text-primary" data-id="element-181" />
                    Next Steps
                  </h3>
                </div>
                <div className="p-6" data-id="element-182">
                  <ol className="space-y-4" data-id="element-183">
                    <li className="flex items-start" data-id="element-184">
                      <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-100 text-blue-600 text-sm mr-3 flex-shrink-0" data-id="element-185">
                        1
                      </div>
                      <span data-id="element-186">
                        Review all system specifications and financial details
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-187">
                      <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-100 text-blue-600 text-sm mr-3 flex-shrink-0" data-id="element-188">
                        2
                      </div>
                      <span data-id="element-189">Contact us if you have any questions</span>
                    </li>
                    <li className="flex items-start" data-id="element-190">
                      <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-100 text-blue-600 text-sm mr-3 flex-shrink-0" data-id="element-191">
                        3
                      </div>
                      <span data-id="element-192">
                        Accept the quote to begin the installation process
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-193">
                      <div className="flex items-center justify-center h-6 w-6 rounded-full bg-blue-100 text-blue-600 text-sm mr-3 flex-shrink-0" data-id="element-194">
                        4
                      </div>
                      <span data-id="element-195">Schedule a site assessment appointment</span>
                    </li>
                  </ol>
                </div>
              </div>
              <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-196">
                <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-197">
                  <h3 className="font-semibold flex items-center" data-id="element-198">
                    <Check className="h-4 w-4 mr-2 text-primary" data-id="element-199" />
                    Available Actions
                  </h3>
                </div>
                <div className="p-6" data-id="element-200">
                  <div className="grid grid-cols-1 gap-4" data-id="element-201">
                    <button className="inline-flex items-center justify-center px-4 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors" data-id="element-202">
                      <Check className="h-4 w-4 mr-2" data-id="element-203" />
                      Accept Proposal
                    </button>
                    <button className="inline-flex items-center justify-center px-4 py-3 bg-muted text-foreground rounded-md border hover:bg-muted/80 transition-colors" data-id="element-204">
                      <Download className="h-4 w-4 mr-2" data-id="element-205" />
                      Download PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>;
      case 'system':
        return <div className="space-y-8" data-id="element-206">
            <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-207">
              <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-208">
                <h3 className="font-semibold flex items-center" data-id="element-209">
                  <Zap className="h-4 w-4 mr-2 text-primary" data-id="element-210" />
                  System Overview
                </h3>
              </div>
              <div className="p-6" data-id="element-211">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-212">
                  <div className="p-4 rounded-lg bg-blue-50" data-id="element-213">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-214">
                      Total Capacity
                    </p>
                    <p className="font-medium text-lg" data-id="element-215">20.5 kWp</p>
                  </div>
                  <div className="p-4 rounded-lg bg-blue-50" data-id="element-216">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-217">
                      System Type
                    </p>
                    <p className="font-medium text-lg" data-id="element-218">
                      Grid-Tied with Battery Backup
                    </p>
                  </div>
                  <div className="p-4 rounded-lg bg-blue-50" data-id="element-219">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-220">
                      Installation Type
                    </p>
                    <p className="font-medium text-lg" data-id="element-221">
                      Roof-Mounted Solar System
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-222">
              <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-223">
                <h3 className="font-semibold flex items-center" data-id="element-224">
                  <Sun className="h-4 w-4 mr-2 text-primary" data-id="element-225" />
                  Solar Panels
                </h3>
              </div>
              <div className="p-6" data-id="element-226">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-227">
                  <div data-id="element-228">
                    <div className="flex justify-between items-center mb-4 pb-4 border-b" data-id="element-229">
                      <div data-id="element-230">
                        <p className="text-sm text-muted-foreground mb-1" data-id="element-231">
                          Count
                        </p>
                        <p className="font-medium" data-id="element-232">33 panels</p>
                      </div>
                      <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-233">
                        <span className="font-bold" data-id="element-234">33</span>
                      </div>
                    </div>
                    <div data-id="element-235">
                      <p className="text-sm text-muted-foreground mb-1" data-id="element-236">
                        Brand & Model
                      </p>
                      <p className="font-medium" data-id="element-237">JA Solar JAM66D45-620/LB</p>
                    </div>
                  </div>
                  <div data-id="element-238">
                    <div className="flex justify-between items-center mb-4 pb-4 border-b" data-id="element-239">
                      <div data-id="element-240">
                        <p className="text-sm text-muted-foreground mb-1" data-id="element-241">
                          Wattage per Panel
                        </p>
                        <p className="font-medium" data-id="element-242">620W</p>
                      </div>
                      <div className="h-12 w-12 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-243">
                        <span className="font-bold" data-id="element-244">620W</span>
                      </div>
                    </div>
                    <div data-id="element-245">
                      <p className="text-sm text-muted-foreground mb-1" data-id="element-246">
                        Total Capacity
                      </p>
                      <p className="font-medium" data-id="element-247">20460W</p>
                    </div>
                  </div>
                  <div className="col-span-2" data-id="element-248">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-249">
                      Warranty
                    </p>
                    <div className="flex items-center" data-id="element-250">
                      <div className="px-3 py-1 rounded-full bg-green-100 text-green-600 text-sm mr-2" data-id="element-251">
                        25 years performance
                      </div>
                      <div className="px-3 py-1 rounded-full bg-blue-100 text-blue-600 text-sm" data-id="element-252">
                        12 years product
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-253">
              <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-254">
                <h3 className="font-semibold flex items-center" data-id="element-255">
                  <Zap className="h-4 w-4 mr-2 text-primary" data-id="element-256" />
                  Inverter
                </h3>
              </div>
              <div className="p-6" data-id="element-257">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-258">
                  <div data-id="element-259">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-260">
                      Brand & Model
                    </p>
                    <p className="font-medium" data-id="element-261">
                      GivEnergy 3 Phase Hybrid Inverter 20kW
                    </p>
                  </div>
                  <div data-id="element-262">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-263">
                      Capacity
                    </p>
                    <p className="font-medium" data-id="element-264">40kW</p>
                  </div>
                  <div data-id="element-265">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-266">
                      Efficiency
                    </p>
                    <div className="flex items-center" data-id="element-267">
                      <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center text-green-600 mr-2" data-id="element-268">
                        <span className="font-bold" data-id="element-269">97%</span>
                      </div>
                      <span className="font-medium" data-id="element-270">Conversion Efficiency</span>
                    </div>
                  </div>
                  <div data-id="element-271">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-272">
                      Warranty
                    </p>
                    <p className="font-medium" data-id="element-273">
                      10 years standard, extendable to 25 years
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-274">
              <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-275">
                <h3 className="font-semibold flex items-center" data-id="element-276">
                  <Battery className="h-4 w-4 mr-2 text-primary" data-id="element-277" />
                  Battery Storage
                </h3>
              </div>
              <div className="p-6" data-id="element-278">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-279">
                  <div data-id="element-280">
                    <div className="flex justify-between items-center mb-4 pb-4 border-b" data-id="element-281">
                      <div data-id="element-282">
                        <p className="text-sm text-muted-foreground mb-1" data-id="element-283">
                          Capacity
                        </p>
                        <p className="font-medium" data-id="element-284">21.48kWh</p>
                      </div>
                      <div className="h-12 w-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-600" data-id="element-285">
                        <span className="font-bold" data-id="element-286">21.48</span>
                      </div>
                    </div>
                    <div data-id="element-287">
                      <p className="text-sm text-muted-foreground mb-1" data-id="element-288">
                        Brand & Model
                      </p>
                      <p className="font-medium" data-id="element-289">i-G3N i-Stack 5.37kWh</p>
                    </div>
                  </div>
                  <div data-id="element-290">
                    <div className="flex justify-between items-center mb-4 pb-4 border-b" data-id="element-291">
                      <div data-id="element-292">
                        <p className="text-sm text-muted-foreground mb-1" data-id="element-293">
                          Units
                        </p>
                        <p className="font-medium" data-id="element-294">4</p>
                      </div>
                      <div className="h-12 w-12 rounded-full bg-orange-100 flex items-center justify-center text-orange-600" data-id="element-295">
                        <span className="font-bold" data-id="element-296">4</span>
                      </div>
                    </div>
                    <div data-id="element-297">
                      <p className="text-sm text-muted-foreground mb-1" data-id="element-298">
                        Backup Duration
                      </p>
                      <p className="font-medium" data-id="element-299">~12 hours</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>;
      case 'financial':
        return <div className="space-y-8" data-id="element-300">
            <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-301">
              <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-302">
                <h3 className="font-semibold flex items-center" data-id="element-303">
                  <DollarSign className="h-4 w-4 mr-2 text-primary" data-id="element-304" />
                  Investment Summary
                </h3>
              </div>
              <div className="p-6" data-id="element-305">
                <div className="text-center mb-6 p-6 bg-purple-50 rounded-lg" data-id="element-306">
                  <p className="text-3xl font-bold text-purple-600" data-id="element-307">R405,600</p>
                  <p className="text-sm text-muted-foreground mt-1" data-id="element-308">
                    Total System Investment
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-309">
                  <div className="p-4 rounded-lg bg-blue-50" data-id="element-310">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-311">
                      Financing Type
                    </p>
                    <p className="font-medium text-lg" data-id="element-312">
                      {proposal.financeOption}
                    </p>
                  </div>
                  <div className="p-4 rounded-lg bg-blue-50" data-id="element-313">
                    <p className="text-sm text-muted-foreground mb-1" data-id="element-314">
                      Loan Term
                    </p>
                    <p className="font-medium text-lg" data-id="element-315">Once-off</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-316">
              <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-317">
                <h3 className="font-semibold flex items-center" data-id="element-318">
                  <DollarSign className="h-4 w-4 mr-2 text-primary" data-id="element-319" />
                  Savings Breakdown
                </h3>
              </div>
              <div className="p-6" data-id="element-320">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-321">
                  <div className="text-center p-4 rounded-lg bg-green-50" data-id="element-322">
                    <p className="text-xl font-bold text-green-600" data-id="element-323">R886</p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-324">
                      Monthly Savings
                    </p>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-green-50" data-id="element-325">
                    <p className="text-xl font-bold text-green-600" data-id="element-326">R10,632</p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-327">
                      Annual Savings
                    </p>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-green-50" data-id="element-328">
                    <p className="text-xl font-bold text-green-600" data-id="element-329">R486,720</p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-330">
                      Lifetime Savings
                    </p>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-purple-50" data-id="element-331">
                    <p className="text-xl font-bold text-purple-600" data-id="element-332">
                      15 years
                    </p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-333">
                      Payback Period
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-334">
              <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-335">
                <h3 className="font-semibold flex items-center" data-id="element-336">
                  <Leaf className="h-4 w-4 mr-2 text-primary" data-id="element-337" />
                  Environmental Impact
                </h3>
              </div>
              <div className="p-6" data-id="element-338">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-339">
                  <div className="text-center p-4 rounded-lg bg-green-50" data-id="element-340">
                    <p className="text-xl font-bold text-green-600" data-id="element-341">N/A</p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-342">
                      CO₂ Reduction (Annual)
                    </p>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-green-50" data-id="element-343">
                    <p className="text-xl font-bold text-green-600" data-id="element-344">N/A</p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-345">
                      CO₂ Reduction (Lifetime)
                    </p>
                  </div>
                  <div className="text-center p-4 rounded-lg bg-green-50" data-id="element-346">
                    <p className="text-xl font-bold text-green-600" data-id="element-347">N/A</p>
                    <p className="text-sm text-muted-foreground mt-1" data-id="element-348">
                      Trees Planted Equivalent
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>;
      case 'timeline':
        return <div className="space-y-8" data-id="element-349">
            <div className="rounded-lg border bg-card shadow-sm overflow-hidden" data-id="element-350">
              <div className="bg-primary/5 px-6 py-4 border-b" data-id="element-351">
                <h3 className="font-semibold flex items-center" data-id="element-352">
                  <Calendar className="h-4 w-4 mr-2 text-primary" data-id="element-353" />
                  Installation Timeline
                </h3>
              </div>
              <div className="p-6" data-id="element-354">
                <div className="space-y-0" data-id="element-355">
                  <div className="relative pl-8 pb-8" data-id="element-356">
                    <div className="absolute top-0 bottom-0 left-[7px] w-0.5 bg-green-500" data-id="element-357"></div>
                    <div className="absolute -left-0 top-0" data-id="element-358">
                      <div className="h-4 w-4 rounded-full bg-green-500 ring-4 ring-green-100" data-id="element-359"></div>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg ml-4" data-id="element-360">
                      <h4 className="font-medium" data-id="element-361">Quote Accepted</h4>
                      <p className="text-sm text-muted-foreground" data-id="element-362">
                        Estimated: Aug 20, 2025
                      </p>
                      <p className="text-xs text-muted-foreground mt-2" data-id="element-363">
                        The customer accepts the proposal and signs the contract
                      </p>
                    </div>
                  </div>
                  <div className="relative pl-8 pb-8" data-id="element-364">
                    <div className="absolute top-0 bottom-0 left-[7px] w-0.5 bg-muted" data-id="element-365"></div>
                    <div className="absolute -left-0 top-0" data-id="element-366">
                      <div className="h-4 w-4 rounded-full bg-muted ring-4 ring-muted/20" data-id="element-367"></div>
                    </div>
                    <div className="bg-muted/10 p-4 rounded-lg ml-4" data-id="element-368">
                      <h4 className="font-medium" data-id="element-369">Site Assessment</h4>
                      <p className="text-sm text-muted-foreground" data-id="element-370">
                        Estimated: Aug 25, 2025
                      </p>
                      <p className="text-xs text-muted-foreground mt-2" data-id="element-371">
                        Our engineers will visit your property to finalize
                        design details
                      </p>
                    </div>
                  </div>
                  <div className="relative pl-8 pb-8" data-id="element-372">
                    <div className="absolute top-0 bottom-0 left-[7px] w-0.5 bg-muted" data-id="element-373"></div>
                    <div className="absolute -left-0 top-0" data-id="element-374">
                      <div className="h-4 w-4 rounded-full bg-muted ring-4 ring-muted/20" data-id="element-375"></div>
                    </div>
                    <div className="bg-muted/10 p-4 rounded-lg ml-4" data-id="element-376">
                      <h4 className="font-medium" data-id="element-377">Permitting & Approvals</h4>
                      <p className="text-sm text-muted-foreground" data-id="element-378">
                        Estimated: Sep 10, 2025
                      </p>
                      <p className="text-xs text-muted-foreground mt-2" data-id="element-379">
                        We'll handle all necessary permits and utility approvals
                      </p>
                    </div>
                  </div>
                  <div className="relative pl-8 pb-8" data-id="element-380">
                    <div className="absolute top-0 bottom-0 left-[7px] w-0.5 bg-muted" data-id="element-381"></div>
                    <div className="absolute -left-0 top-0" data-id="element-382">
                      <div className="h-4 w-4 rounded-full bg-muted ring-4 ring-muted/20" data-id="element-383"></div>
                    </div>
                    <div className="bg-muted/10 p-4 rounded-lg ml-4" data-id="element-384">
                      <h4 className="font-medium" data-id="element-385">Installation Begins</h4>
                      <p className="text-sm text-muted-foreground" data-id="element-386">
                        Estimated: Sep 20, 2025
                      </p>
                      <p className="text-xs text-muted-foreground mt-2" data-id="element-387">
                        Our installation team will begin work at your property
                      </p>
                    </div>
                  </div>
                  <div className="relative pl-8" data-id="element-388">
                    <div className="absolute -left-0 top-0" data-id="element-389">
                      <div className="h-4 w-4 rounded-full bg-muted ring-4 ring-muted/20" data-id="element-390"></div>
                    </div>
                    <div className="bg-muted/10 p-4 rounded-lg ml-4" data-id="element-391">
                      <h4 className="font-medium" data-id="element-392">System Commissioning</h4>
                      <p className="text-sm text-muted-foreground" data-id="element-393">
                        Estimated: Sep 25, 2025
                      </p>
                      <p className="text-xs text-muted-foreground mt-2" data-id="element-394">
                        Final testing and activation of your solar system
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>;
      default:
        return null;
    }
  };
  return <div className="w-full min-h-screen bg-background" data-id="element-395">
      {/* Header Section */}
      <div className="border-b sticky top-0 bg-background z-10" data-id="element-396">
        <div className="max-w-6xl mx-auto px-6 py-4" data-id="element-397">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-398">
            <div data-id="element-399">
              <div className="flex items-center mb-1" data-id="element-400">
                <button onClick={handleBackClick} className="flex items-center text-primary mr-4 hover:underline" data-id="element-401">
                  <ArrowLeft className="h-4 w-4 mr-2" data-id="element-402" />
                  {cameFromProposals ? 'Back to Proposals' : 'Back to User'}
                </button>
                <button onClick={handleBackClick} className="ml-auto md:hidden p-1 rounded-full hover:bg-muted/50" data-id="element-403">
                  <X className="h-5 w-5" data-id="element-404" />
                </button>
              </div>
              <div className="flex items-center justify-between" data-id="element-405">
                <div data-id="element-406">
                  <h1 className="text-xl font-bold flex items-center" data-id="element-407">
                    <Home className="h-5 w-5 mr-2 text-primary" data-id="element-408" />
                    Residential Solar - {proposal.id}
                  </h1>
                  <p className="text-sm text-muted-foreground" data-id="element-409">
                    Quote Reference: SQL-70396898-edd4
                  </p>
                </div>
                <button onClick={handleBackClick} className="hidden md:block p-1 rounded-full hover:bg-muted/50" data-id="element-410">
                  <X className="h-5 w-5" data-id="element-411" />
                </button>
              </div>
            </div>
            <div className="flex items-center space-x-3 md:ml-auto" data-id="element-412">
              <div className={`px-3 py-1 text-xs font-medium rounded-full ${proposal.financeStatus === 'finance accepted' ? 'bg-green-100 text-green-800' : proposal.financeStatus === 'declined' ? 'bg-red-100 text-red-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-413">
                Finance: {proposal.financeStatus}
              </div>
              <div className={`px-3 py-1 text-xs font-medium rounded-full ${proposal.projectStatus === 'commissioned' ? 'bg-green-100 text-green-800' : proposal.projectStatus === 'accepted' || proposal.projectStatus === 'scheduled' ? 'bg-blue-100 text-blue-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-414">
                Status: {proposal.projectStatus}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Tabs Navigation */}
      <div className="border-b bg-muted/20" data-id="element-415">
        <div className="max-w-6xl mx-auto px-6" data-id="element-416">
          <div className="flex overflow-x-auto scrollbar-hide" data-id="element-417">
            <button className={`px-6 py-4 font-medium text-sm border-b-2 transition-colors ${activeTab === 'overview' ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('overview')} data-id="element-418">
              Overview
            </button>
            <button className={`px-6 py-4 font-medium text-sm border-b-2 transition-colors ${activeTab === 'system' ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('system')} data-id="element-419">
              System
            </button>
            <button className={`px-6 py-4 font-medium text-sm border-b-2 transition-colors ${activeTab === 'financial' ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('financial')} data-id="element-420">
              Financial
            </button>
            <button className={`px-6 py-4 font-medium text-sm border-b-2 transition-colors ${activeTab === 'timeline' ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}`} onClick={() => setActiveTab('timeline')} data-id="element-421">
              Timeline
            </button>
          </div>
        </div>
      </div>
      {/* Tab Content */}
      <div className="max-w-6xl mx-auto px-6 py-8" data-id="element-422">{renderTabContent()}</div>
    </div>;
};